var render = function render(){
  var _vm$item, _vm$item2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "sidebar-menu-item",
    class: [`menu-item-level-${_vm.item.level}`, {
      'menu-item-active': _vm.isActive,
      'sub-menu-item-active': _vm.isSubItemActive,
      'filtered-title': (_vm$item = _vm.item) === null || _vm$item === void 0 ? void 0 : _vm$item.filteredTitle
    }],
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return function (e) {
          return _vm.onItemClick(e);
        }.apply(null, arguments);
      }
    }
  }, [_c('a', {
    staticClass: "menu-item-title",
    style: {
      paddingLeft: _vm.itemLeftPadding
    },
    attrs: {
      "href": _vm.item.href
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return function (e) {
          return e.preventDefault();
        }.apply(null, arguments);
      }
    }
  }, [(_vm$item2 = _vm.item) !== null && _vm$item2 !== void 0 && _vm$item2.filteredTitle ? _c('span', {
    staticClass: "fa fa-solid fa-circle fa-2xs filtered-indicator"
  }) : _vm._e(), _c('div', {
    staticClass: "d-flex justify-content-between align-items-center"
  }, [_vm.isDevice ? _c('span', {
    class: ['fa', `icon`, _vm.deviceCategoryIcon, `mr-2`]
  }) : _c('span', {
    class: ['fa', 'fa-solid', 'fa-lg', _vm.iconClass, 'mr-2']
  }), _c('span', [_vm._v(_vm._s(_vm.item.title) + " ")])]), _vm.hasChildren ? [_c('span', {
    staticClass: "expand-icon-wrapper",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return function (e) {
          return _vm.toggleItem(e);
        }.apply(null, arguments);
      }
    }
  }, [_vm.isCollapsed ? _c('i', {
    staticClass: "fa fa-plus"
  }) : _c('i', {
    staticClass: "fa fa-minus"
  })])] : _vm._e()], 2), _vm.hasChildren ? _c('div', {
    staticClass: "menu-item-children",
    class: {
      collapsed: _vm.isCollapsed
    },
    attrs: {
      "id": `children-${_vm.item.id}`
    }
  }, _vm._l(_vm.children, function (childItem) {
    return _c('SidebarMenuItem', {
      key: `${childItem.id}-${childItem.href}`,
      attrs: {
        "id": childItem.href,
        "item": childItem,
        "collapse": _vm.checkCollapsed(childItem) || _vm.openItemId !== null && _vm.openItemId !== childItem.id
      },
      on: {
        "item-opened": function ($event) {
          _vm.openItemId = $event;
        }
      }
    });
  }), 1) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }